module.exports = __webpack_public_path__ + "media/images/products/tv-desktop-illustration-4ce6ff95721d693487ecc21e404828f3.svg";